export * from './types';
import { PagerView } from './PagerView';
export default PagerView;
